export default function Delefunktion() {
  return (
    <div className="container mt-20 mx-auto">
      <div>
        <h4 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Delefunktion & brugerrettigheder
        </h4>

        <p>
          I denne video demonstreres, hvordan man deler mapper og fraser med
          kollegaer eller andre brugere. Processen er ens for både enkeltfraser
          og mapper. Ved at benytte prikmenuen ud for enten en frase eller mappe
          kan man vælge deleindstillinger. Herefter genereres et link, som kan
          kopieres og sendes til den ønskede modtager.
        </p>

        <p>
          Når modtageren åbner linket, tilføjes frasen eller mappen automatisk
          til deres bibliotek af fraser under abonnementsfraser. Efter at en
          person har tilføjet frasen, kan ejeren af frasen se hvem der har
          adgang til den ved at gå ind i deleindstillinger igen.
        </p>

        <p>
          Som standard kan man læse og kopiere frasen via det tilsendte link,
          men ejeren af frasen eller mappen kan ændre læseren til admin. Admins
          har flere rettigheder, såsom at oprette nye fraser, slette fraser og
          redigere fraser. Desuden kan admins fjerne adgangen til frasen ved at
          trykke på skraldespandsikonet.
        </p>

        <p>
          Delefunktionen er særligt brugbar i miljøer, hvor afdelingslæger eller
          faste læger er admins, og deres personale bruger de fraser, som
          lægerne administrerer og opdaterer. Det kan også være nyttigt for
          studerende, der deler fraser til brug i klinikken eller til fælles
          noter. Uanset anvendelsesområdet, sparer delingen af fraser tid og
          muliggør samarbejde på tværs af brugere.
        </p>
      </div>

      <div className="mt-10">
        <iframe
          width="560"
          height="315"
          className="h-[200px] md:h-[600px]"
          style={{ width: "100%", borderRadius: "10px" }}
          src="https://www.youtube.com/embed/704aRvs5tvk?si=ypjaUiGqncfgb2rG"
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
}
